// @flow
import { tryParseFeature, parseFeature } from 'utils/geometry';
import bbox from '@turf/bbox';

import { drawingFinished } from 'actions/drawOverlay';
import { setFitBounds } from 'actions/map';

export const COORDINATE_INPUT_DIALOG_TOGGLE = 'coordinateInputDialog/TOGGLE';
export const COORDINATE_INPUT_DIALOG_TOGGLE_INVALID =
  'coordinateInputDialog/TOGGLE_INVALID';
export const COORDINATE_INPUT_DIALOG_SET_GEOMETRY_FORMAT =
  'coordinateInputDialog/SET_GEOMETRY_FORMAT';

export function toggleCoordinateInputDialog(visible) {
  return dispatch => {
    dispatch({
      type: COORDINATE_INPUT_DIALOG_TOGGLE,
      visible,
    });
    dispatch({
      type: COORDINATE_INPUT_DIALOG_TOGGLE_INVALID,
      invalid: false,
    });
  };
}

export function toggleCoordinateInputDialogInvalid(invalid) {
  return {
    type: COORDINATE_INPUT_DIALOG_TOGGLE_INVALID,
    invalid,
  };
}

export function setGeometryFormat(geometryFormat) {
  return {
    type: COORDINATE_INPUT_DIALOG_SET_GEOMETRY_FORMAT,
    geometryFormat,
  };
}

export function submitCoordinateList(coordinateList) {
  return async (dispatch, getState) => {
    const {
      coordinateInputDialog: { geometryFormat },
    } = getState();

    try {
      const feature =
        geometryFormat === 'autodetect'
          ? await tryParseFeature(coordinateList)
          : await parseFeature(coordinateList, geometryFormat);

      dispatch(drawingFinished(feature));
      dispatch(toggleCoordinateInputDialogInvalid(false));
      dispatch(setFitBounds(bbox(feature)));
      dispatch(toggleCoordinateInputDialog(false));
    } catch (e) {
      dispatch(toggleCoordinateInputDialogInvalid(true));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/coordinateInputDialog.js